import { Tooltip } from 'components/system/Tooltip';

import NotificationsButton from './NotificationsButton';
import NotificationsMenu from './NotificationsMenu';
import { useAnchorElement } from './hooks/useAnchorElement';
import { useNotificationsCount } from './hooks/useNotificationsCount';

const Notifications = () => {
  const {
    anchorEl,
    handleCloseAnchorElement,
    isAnchorElementOpen,
    toggleAnchorElement,
  } = useAnchorElement();

  const { unreadCount } = useNotificationsCount();

  return (
    <>
      <Tooltip
        arrow
        placement="bottom"
        enterDelay={300}
        enterNextDelay={0}
        title="Notifications"
      >
        <NotificationsButton
          onClick={toggleAnchorElement}
          newNotifications={unreadCount ?? 0}
        />
      </Tooltip>
      <NotificationsMenu
        anchorEl={anchorEl}
        isOpen={isAnchorElementOpen}
        onClose={handleCloseAnchorElement}
        unreadCount={unreadCount ?? 0}
      />
    </>
  );
};

export default Notifications;
